import Program from 'nanogl/program'
import Chunk from 'nanogl-pbr/Chunk'
import ChunksSlots from 'nanogl-pbr/ChunksSlots'
import Input, { ShaderType, Uniform } from 'nanogl-pbr/Input'

import FPSLimiter from '@/webgl/FPSLimiter'
import { randomInt } from '@/webgl/math'
import { TimeEntity } from '@/webgl/runner/entities/Time'

export default class ExpressionMaskChunk extends Chunk {
  strideCount: number = 0

  private settings: Input
  private settingsUniform: Uniform
  private limiter: FPSLimiter

  constructor(
    /** Automatic expression update */
    readonly time: TimeEntity,
    /** Number of square from the flipbook */
    readonly flipbookSize: number,
    /** The expesion count */
    readonly expressionCount: number
  ) {
    super(true, true)

    const size = new Input('FlipBookSize', 1, ShaderType.FRAGMENT)
    size.attachConstant([flipbookSize])
    this.addChild(size)

    this.addChild((this.settings = new Input('CurrentFace', 1, ShaderType.FRAGMENT)))
    this.settingsUniform = this.settings.attachUniform('uCurrentFace')
    this.settingsUniform.set(0)

    this.limiter = new FPSLimiter()
    this.limiter.fps = 2
    this.limiter.enabled = true
  }

  setup(prg: Program): void {
    if (this.limiter.step(this.time.deltaTime)) {
      let face = this.settingsUniform.value[0]
      while (face == this.settingsUniform.value[0]) {
        face = randomInt(0, this.expressionCount - 1)
      }
      this.settingsUniform.set(face)
    }
  }

  protected _genCode(slots: ChunksSlots): void {
    slots.add(
      'postf',
      /*glsl*/ `
      vec2 uv = (baseColor_texCoord() + vec2(CurrentFace(), 0.0) ) * vec2( 1.0 / FlipBookSize(), 1.0 ) ;
      float a = texture2D(tex_basecolor, uv).g;
      FragColor = vec4( vec3(0.996, 0.82, 0.784), a );
      `
    )
  }
}
